import React, { useEffect, useState } from "react"
import { Container, Form, Input, Label } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import "../../../assets/css/HolidayList/ListOfHolidays.css"
import AddHoliday from "../../../assets/images/Holiday/AddHoliday.jpg"
import EditHoliday from "../../../assets/images/Holiday/EditHoliday.jpg"
import { Table, Row, Col, Card, CardBody, Modal } from "reactstrap"
// common component
import Pagination from "components/Common/Pagination"
// Hover card
import Loader from "pages/Separate/Loader"
import Swal from "sweetalert2"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { 
  fetchData,
  FetchPostData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage" 
import moment from "moment"

function getYearOptions(till = 2010) {
  const yearsOptions = []
  for (let year = new Date().getFullYear(); year >= till; year--)
    yearsOptions.push(year)

  return yearsOptions
}

const token = secureLocalStorage.getItem("auth_token") || ""
function TableContainer({
  columns,
  setLoading,
  data,
  fetchLeaveData,
  year,
  setYear,
}) {
  const [fixedContent, setFixedContent] = useState(false)
  const [formData, setFormData] = useState({
    holiday: "",
    date: "",
    comment: "",
  })
  const [addHoliday, setAddHoliday] = useState(false)
  const navigate = useNavigate()

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setAddHoliday(false)
  })

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  const [title, setTitle] = useState("")
  const [name_modal, setNameModal] = useState(false)

  const yearsOptions = useMemo(
    () => getYearOptions(new Date().getFullYear() - 5),
    []
  )

  const handleAddSubmit = async e => {
    e.preventDefault()

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to add this holiday!",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, add it!",
      cancelButtonText: "Cancel",
    })

    if (result.isConfirmed) {
      try {
        setLoading(true)

        const response = await FetchPostData(
          setLoading,
          "holidays",
          token,
          formData
        )
        if (response.data?.message == "Holiday created successfully.") {
          Swal.fire({
            icon: "success",
            title: "Holiday Added",
            text: "The holiday has been added successfully!",
          })
          setAddHoliday(false)
          if (year !== new Date().getFullYear()) {
            setYear(new Date().getFullYear())
          } else fetchLeaveData()

          setFormData({
            holiday: "",
            date: "",
            comment: "",
          })
        }
      } catch (err) {
        console.log("API ERROR:", err)
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong ",
        })
      } finally {
        setLoading(false)
      }
    }
  }
  return (
    <div>
      <div
        className={`flex-column fixed-buttons pt-2 mt-3 ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <Link className="btn btn-save  fix-btn btn-label pe-0">
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Add Holiday</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>

      <Row className="m-0 d-flex flex-wrap align-items-center">
        {/* Show dropdown - left */}
        <div className="p-0 col-12 col-md-2 mb-2 mb-md-0 d-flex gap-3">
          <select
            className="form-select"
            style={{ maxWidth: "120px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 25, 50, 100].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>

        {/* Search + Button - right */}
        <div className="p-0 col-12 col-md-10 d-flex justify-content-md-end  ">
          <div className="d-flex align-items-center">
            <div className="me-2 col-2">
              <select
                className="form-select"
                value={year}
                onChange={e => setYear(e.target.value)}
                required
              >
                {yearsOptions.map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            {/* Search Bar */}
            <div className="search-box me-2 mb-2 mb-md-0">
              <div className="position-relative">
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  id="search-bar-0"
                  type="text"
                  className="form-control rounded"
                  placeholder="Search..."
                  value={globalFilter || ""}
                  style={{
                    width: "100%",
                    minWidth: "220px",
                    maxWidth: "300px",
                  }}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>

            {/* Holiday Button */}
            <button
              className="btn btn-save btn-label ms-md-2"
              onClick={() => setAddHoliday(true)}
            >
              <i className="fas fa-plus me-2 label-icon"></i>
              Holiday
            </button>
            <button
              onClick={() => navigate(-1)}
              className=" btn btn-red btn-label ms-3"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              Cancel
            </button>
          </div>
        </div>
      </Row>

      <div className="position-relative">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fix-holiday-header" : ""
            } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true)
                          setTitle(column.Header)
                        }}
                      ></a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

      {/* Add Holiday Popup */}
      <Modal isOpen={addHoliday} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Add Holiday</h5>
          <button
            type="button"
            onClick={() => {
              setAddHoliday(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form
            className="row d-flex justify-content-center align-items-center"
            onSubmit={handleAddSubmit}
          >
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={AddHoliday} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-8  ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Holiday Name <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Enter Holiday Name"
                      required
                      value={formData.holiday}
                      onChange={e =>
                        setFormData({ ...formData, holiday: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    required
                    value={formData.date}
                    onChange={e =>
                      setFormData({ ...formData, date: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="col-md-12 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Comment <span className="text-danger">*</span>
                  </Label>
                  <textarea
                    type="text"
                    // value={lead_belong}
                    placeholder="Add Comment Here.."
                    required
                    className="form-control"
                    style={{ height: "150px" }}
                    value={formData.comment}
                    onChange={e =>
                      setFormData({ ...formData, comment: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="my-4 text-center">
                <button type="submit" className=" btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => setAddHoliday(false)}
                  className="btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </button>
              </div>
            </div>

            {/* </div> */}
          </Form>
        </div>
      </Modal>
    </div>
  )
}

const ListOfHolidays = () => {
  const [deleteData, setDeleteData] = useState([])
  const [leaveData, setLeaveData] = useState([])
  const [editFormData, setEditFormData] = useState({
    id: "",
    holiday: "",
    date: "",
    comment: "",
  })
  const [year, setYear] = useState(new Date().getFullYear())

  useEffect(() => {
    fetchLeaveData()
  }, [year])

  const fetchLeaveData = async () => {
    setLoading(true)
    try {
      const response = await fetchData(setLoading, `holidays/${year}`, token)
      // console.log("Leave Data", response.data)
      setLeaveData(response.data?.sort((a, b) => b.id - a.id) || [])
    } catch (err) {
      console.log("API ERROR:", err.response || err)
    } finally {
      setLoading(false)
    }
  }

  //meta title
  document.title = "List Of Holidays | Zithas Crm"
  const [allData, setAllData] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [modal_Access, setAccessDenied] = useState(false)
  const [editHoliday, setEditHoliday] = useState(false)

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setEditHoliday(false)
  })

  const handleDelete = async id => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this holiday!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    })

    if (result.isConfirmed) {
      try {
        setLoading(true)

        await fetchData(setLoading, `deleteHolidays/${id}`, token)

        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Holiday deleted successfully",
        })

        fetchLeaveData()
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong",
        })
      } finally {
        setLoading(false)
      }
    }
  }

  const navigate = useNavigate()

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center id_box",
        Cell: row => (
          <div style={{ textAlign: "center" }}>{row.row.index + 1}</div>
        ),
      },
      {
        Header: "Holiday Name",
        accessor: "festival_name",
        grow: false,
        className: "festival_name_box",
      },

      {
        Header: () => {
          return <div style={{ textAlign: "center" }}>Date</div>
        },
        accessor: "date",
        isInfoIcon: true,
        className: "date_box",
        Cell: row => (
          <div style={{ textAlign: "center" }}>
            {moment(row.value).format("DD-MM-YYYY")}
          </div>
        ),
      },
      {
        Header: () => {
          return <div style={{ textAlign: "center" }}>Day</div>
        },
        accessor: "day",
        isInfoIcon: true,
        className: "day_box",
        Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>,
      },

      {
        Header: "Comment",
        accessor: "comment",
        isInfoIcon: true,
        className: "comment_box",
      },

      {
        Header: () => {
          return <div style={{ textAlign: "center" }}>Action</div>
        },
        accessor: "action",
        className: "text-center action_box",
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center">
              <button
                onClick={() => {
                  const rowData = cellProps.row.original

                  setEditFormData({
                    id: rowData.id,
                    holiday: rowData.festival_name,
                    date: rowData.date,
                    comment: rowData.comment,
                  })

                  setEditHoliday(true)
                }}
                className="btn btn-sm me-1 btn-outline-secondary"
                title="Edit Holiday"
              >
                <i className="fa fa-pencil-alt"></i>
              </button>

              <button
                onClick={() => handleDelete(cellProps.row.original.id)}
                className="btn btn-sm me-1 btn-outline-secondary"
                title="Delete Holiday"
              >
                <i className="fa fa-trash-alt text-danger"></i>
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  const data2 = leaveData.map(item => ({
    id: item.id,
    festival_name: item.holiday, // map API 'holiday' to table 'festival_name'
    date: item.date,
    day: new Date(item.date).toLocaleDateString("en-US", { weekday: "long" }),
    comment: item.comment,
  }))

  const handleUpdateHoliday = async e => {
    e.preventDefault()
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this holiday?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "Cancel",
    })

    if (!result.isConfirmed) return

    try {
      setLoading(true)

      const formData = new FormData()
      formData.append("id", editFormData.id)
      formData.append("holiday", editFormData.holiday)
      formData.append("date", editFormData.date)
      formData.append("comment", editFormData.comment)

      const response = await FetchPostData(
        setLoading,
        "updateHolidays",
        token,
        formData
      )
      console.log(response.data)
      if (response.data?.message == "Holiday created successfully.") {
      }
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Holiday updated successfully",
      })

      setEditHoliday(false)
      fetchLeaveData()
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Dashboard"}
            breadcrumbItem={"List Of Holidays"}
          />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data2}
                      allData={allData}
                      deleteData={deleteData}
                      setAccessDenied={setAccessDenied}
                      setLoading={setLoading}
                      fetchLeaveData={fetchLeaveData}
                      year={year}
                      setYear={setYear}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Edit Holiday Popup */}
      <Modal isOpen={editHoliday} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Edit Holiday</h5>
          <button
            type="button"
            onClick={() => {
              setEditHoliday(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form
            onSubmit={handleUpdateHoliday}
            className="row d-flex justify-content-center align-items-center"
          >
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={EditHoliday} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-8  ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Holiday Name <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Enter Holiday Name"
                      value={editFormData.holiday}
                      onChange={e =>
                        setEditFormData({
                          ...editFormData,
                          holiday: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    value={editFormData.date}
                    onChange={e =>
                      setEditFormData({ ...editFormData, date: e.target.value })
                    }
                    required
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="col-md-12 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Comment <span className="text-danger">*</span>
                  </Label>
                  <textarea
                    type="text"
                    // value={lead_belong}
                    placeholder="Add Comment Here.."
                    className="form-control"
                    value={editFormData.comment}
                    onChange={e =>
                      setEditFormData({
                        ...editFormData,
                        comment: e.target.value,
                      })
                    }
                    required
                    style={{ height: "150px" }}
                  />
                </div>
              </div>

              <div className="my-4 text-center">
                <button
                  // onClick={handleUpdateHoliday}
                  className="btn btn-save btn-label"
                >
                  <i className="fas fa-save me-2 label-icon"></i>
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => setEditHoliday(false)}
                  className="btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default ListOfHolidays
